export default "__VITE_ASSET__4lY3yRXg__"